import { useState } from "react";
import QRCode from "react-qr-code";
import API from "../../lib/api";
import { Button } from "../ui/button";
import { Download, Printer, Copy, ArrowsClockwise, ArrowSquareOut, Tag } from "@phosphor-icons/react";
import { toast } from "sonner";
import { openAuthFile, downloadAuthFile } from "../../lib/fileOpen";

export function AssetQrCard({ asset, canEdit, onChanged }) {
  const [busy, setBusy] = useState(false);
  const url = asset.passport_url;

  const copy = async () => { try { await navigator.clipboard.writeText(url); toast.success("Passport link copied"); } catch { toast.error("Copy failed"); } };
  const regenerate = async () => {
    if (!window.confirm("Issue a new passport code? Labels already printed with the old code will stop working.")) return;
    setBusy(true);
    try { await API.post(`/assets/${asset.id}/regenerate-code`); toast.success("New passport code issued"); onChanged?.(); } catch { toast.error("Couldn't regenerate"); } finally { setBusy(false); }
  };

  return (
    <div className="border border-border rounded-lg p-5 bg-card" data-testid="asset-qr-card">
      <div className="flex items-center justify-between mb-3">
        <h3 className="font-semibold text-sm">Asset passport</h3>
        <span className="font-mono text-[11px] px-2 py-0.5 rounded bg-muted" data-testid="asset-passport-code">{asset.passport_code}</span>
      </div>
      <div className="flex justify-center p-3 rounded-md bg-white">
        <QRCode value={url} size={150} bgColor="#ffffff" fgColor="#191A12" />
      </div>
      {asset.tag_code && <p className="mt-3 text-xs flex items-center justify-center gap-1.5 text-muted-foreground"><Tag size={12} /> Physical tag <span className="font-mono font-semibold text-foreground" data-testid="asset-tag-chip">{asset.tag_code}</span></p>}
      <p className="text-[11px] text-muted-foreground text-center mt-2">Anyone scanning sees status, service history and can report a fault — no login needed.</p>
      <div className="grid grid-cols-2 gap-2 mt-4">
        <Button variant="outline" size="sm" onClick={() => downloadAuthFile(`/assets/${asset.id}/qr-label`, `asset-label-${asset.passport_code}.png`)} data-testid="asset-label-download"><Download size={14} className="mr-1" /> Label</Button>
        <Button variant="outline" size="sm" onClick={() => openAuthFile(`/assets/${asset.id}/qr-label`)} data-testid="asset-label-print"><Printer size={14} className="mr-1" /> Print</Button>
        <Button variant="outline" size="sm" onClick={copy} data-testid="asset-passport-copy"><Copy size={14} className="mr-1" /> Copy link</Button>
        <Button variant="outline" size="sm" onClick={() => window.open(url, "_blank", "noopener")} data-testid="asset-passport-open"><ArrowSquareOut size={14} className="mr-1" /> Preview</Button>
      </div>
      {canEdit && <button type="button" onClick={regenerate} disabled={busy} className="mt-3 w-full text-[11px] text-muted-foreground hover:text-foreground inline-flex items-center justify-center gap-1" data-testid="asset-passport-regenerate"><ArrowsClockwise size={12} /> Issue a new code</button>}
    </div>
  );
}
